import { render, staticRenderFns } from "./NewFormDocument.vue?vue&type=template&id=49e394d5&"
import script from "./NewFormDocument.vue?vue&type=script&lang=js&"
export * from "./NewFormDocument.vue?vue&type=script&lang=js&"
import style0 from "./NewFormDocument.vue?vue&type=style&index=0&id=49e394d5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports